// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const LibraryCard = () => ({
   replace: true,
   templateUrl: '/assets/libraryCard/libraryCard.html',
   controllerAs: 'libraryCard',
   controller: LibraryCardController
})

const LibraryCardLeftBar = () => ({
   replace: true,
   templateUrl: '/assets/libraryCard/libraryCardLeftBar.html',
   controllerAs: 'vm',
   controller: LibraryCardLeftBarController
})

const LibraryCardItemList = () => ({
   replace: true,
   templateUrl: '/assets/libraryCard/libraryCardListItem.html',
   controllerAs: 'vm',
   controller: LibraryCardItemListController,

   bindToController: {
      doc: '<',
      hideThumbnail: '<'
   }
})

const LibraryCardRequestList = () => ({
   replace: true,
   templateUrl: '/assets/libraryCard/libraryCardRequestList.html',
   controllerAs: 'vm',
   controller: 'libraryCardRequestListController',

   bindToController: {
      reloadTrigger: '<',
      newRequestMade: '<'
   }
})

const LibraryCardCheckoutList = () => ({
   replace: true,
   templateUrl: '/assets/libraryCard/libraryCardCheckoutList.html',
   controllerAs: 'vm',
   controller: 'libraryCardCheckoutListController',

   bindToController: {
      reloadTrigger: '<'
   }
})

const LibraryCardMessageList = () => ({
   replace: true,
   templateUrl: '/assets/libraryCard/libraryCardMessageList.html',
   controllerAs: 'vm',
   controller: 'libraryCardMessageListController',

   bindToController: {
      reloadTrigger: '<'
   }
})

const LibraryCardFineList = () => ({
   replace: true,
   templateUrl: '/assets/libraryCard/libraryCardFineList.html',
   controllerAs: 'vm',
   controller: 'libraryCardFineListController',

   bindToController: {
      reloadTrigger: '<'
   }
})

const PatronDetailField = () => ({
   replace: true,
   templateUrl: '/assets/libraryCard/patronDetailField.html',
   controllerAs: 'vm',
   controller: PatronDetailFieldController,

   bindToController: {
      model: '<',
      addField: '&',
      removeField: '&',
      reloadTrigger: '<'
   }
})

const LibraryCardPersonalDetails = () => ({
   replace: true,
   templateUrl: '/assets/libraryCard/libraryCardPersonalDetails.html',
   controllerAs: 'vm',
   controller: 'libraryCardPersonalDetailsController',

   bindToController: {
      reloadTrigger: '<'
   }
})

const LibraryCardReadingHistoryList = () => ({
   replace: true,
   templateUrl: '/assets/libraryCard/libraryCardReadingHistoryList.html',
   controllerAs: 'vm',
   controller: 'libraryCardReadingHistoryListController',

   bindToController: {
      reloadTrigger: '<'
   }
})

class LibraryCardController {
   $location: any
   $scope: any
   $timeout: any
   alerts: any
   configService: any
   i18n: any
   mode: any
   modeTranslated: any
   options: any
   reloadTrigger: any
   sierraService: any
   constructor($scope: any, $location: any, $timeout: any, translationService: any, alertService: any, configService: any, sierraService: any, $rootScope: any, $authEvents: any) {
      this.$scope = $scope
      this.$location = $location
      this.$timeout = $timeout
      this.configService = configService
      this.sierraService = sierraService
      this.i18n = translationService
      // set up menu options based on sections that are enabled via customizer
      this.options = _.map(this.configService.data.libraryCard.sections, (enabledSection: any) => { 
         enabledSection.translation = this.i18n.translations[enabledSection.name]
         enabledSection.mode = enabledSection.name
         return enabledSection
      })
    
      // set current mode to reflect first option in array
      this.mode = this.options[0].mode
      this.modeTranslated = this.options[0].translation
    
      this.alerts = alertService
      this.reloadTrigger = false

      $rootScope.$on($authEvents.LOGOUTSUCCESS, () => this.mode = this.options[0].mode)
      $rootScope.$on($authEvents.LOGINSUCCESS, () => this.reloadCurrentList())
   }

   showMode(newMode: any) {
      this.resetLibraryCardAlerts()
      this.mode = newMode
      return this.modeTranslated = this.i18n.translations[newMode]
   }

   showLibraryCard() {
      this.resetLibraryCardAlerts()
      // Show first option in menu when coming back to library card
      this.showMode(this.options[0].mode)
      if (this.$location.path() !== '/library_card') { 
         return this.$location.path('/library_card')
      } else {
         return this.$location.path('/')
      }
   }

   resetLibraryCardAlerts() {
      this.alerts.resetAlert('libraryCardError')
      this.alerts.resetAlert('libraryCardListLoadError')
      return this.alerts.resetAlert('libraryCardSuccess')
   }

   reloadCurrentList() {
      this.reloadTrigger = true
      this.resetLibraryCardAlerts()
      return this.$timeout(() => {
      // Do this inside timeout to give onChanges in child component time to detect change
         return this.reloadTrigger = false
      } 
      ,5000)
   }

   displayLibraryCardName() {
      if (this.configService.data.libraryCard.customLibraryName) {
         return this.configService.data.libraryCard.customLibraryName
      } else if (this.sierraService.userInfo.libraryInfo.displayName) {
         return this.sierraService.userInfo.libraryInfo.displayName
      } else {
         return ""
      }
   }
}

class LibraryCardLeftBarController {
   i18n: any
   sierraService: any
   constructor(translationService: any, sierraService: any) {
      this.sierraService = sierraService
      this.i18n = translationService
   }
}

class LibraryCardItemListController {
   doc: any
   documentService: any
   i18n: any
   constructor(translationService: any, documentService: any) {
      this.documentService = documentService
      this.i18n = translationService
   }

   $onInit() {
      this.doc.summary = this.documentService.getDocumentSummary(this.doc)
      return this.doc.hasDetailPage = this.documentService.displayDetailPage(this.doc) || this.documentService.displayAIPage(this.doc)
   }
}

class PatronDetailFieldController {
   $scope: any
   getOption: any
   i18n: any
   maxRows: any
   model: any
   translationService: any
   constructor($scope: any, translationService: any) {
      this.$onChanges = this.$onChanges.bind(this)
      this.showThisField = this.showThisField.bind(this)
      this.hasMaxMultipleRows = this.hasMaxMultipleRows.bind(this)
      this.$scope = $scope
      this.translationService = translationService
      this.i18n = this.translationService
      this.$scope.setMode = this.$scope.$parent.vm.setMode
      this.$scope.dateLimits = this.$scope.$parent.vm.dateLimits
      this.$scope.phoneDescription = this.$scope.$parent.vm.phoneDescription
      this.$scope.vm.getOption = this.$scope.$parent.vm.getOption
      this.maxRows = 5
   }

   $onChanges(changesObj: any) {
      if (changesObj.reloadTrigger.currentValue && _.includes(['phones', 'addresses'], (this.model.key))) {
         return this.model.values.forEach((item: any) => {
            return item.value.model = this.getOption(this.model.helperOptions, 'code', item.value.type)
         })
      }
   }

   showThisField() {
      return this.model.hidden = false
   }

   hasMaxMultipleRows() {
      return this.model.values.length >= this.maxRows
   }
}

LibraryCardController.$inject = ['$scope', '$location', '$timeout', 'translationService', 'alertService',  'configService', 'sierraService', '$rootScope', '$authEvents']

LibraryCardLeftBarController.$inject = ['translationService', 'sierraService']

LibraryCardItemListController.$inject = ['translationService', 'documentService']

PatronDetailFieldController.$inject = ['$scope','translationService']

angular.module('summonApp.directives')
   .directive('libraryCard', ['translationService', 'alertService', LibraryCard])
   .directive('libraryCardLeftBar', LibraryCardLeftBar)
   .directive('libraryCardItemList', ['translationService', 'documentService', LibraryCardItemList])
   .directive('libraryCardRequestList', ['sierraService', 'apiService', 'translationService', 'alertService', LibraryCardRequestList])
   .directive('libraryCardCheckoutList', ['sierraService', 'apiService', 'translationService', 'alertService', LibraryCardCheckoutList])
   .directive('libraryCardFineList', ['sierraService', 'apiService', 'translationService', 'alertService', LibraryCardFineList])
   .directive('libraryCardMessageList', ['sierraService', 'translationService', 'alertService', LibraryCardMessageList])
   .directive('libraryCardPersonalDetails', ['sierraService', 'translationService', 'alertService', LibraryCardPersonalDetails])
   .directive('patronDetailField', ['translationService', PatronDetailField])
   .directive('libraryCardReadingHistoryList', ['sierraService', 'apiService', 'translationService', 'alertService', LibraryCardReadingHistoryList])
